"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _templateObject, _templateObject2;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));

var StyledButton = _styledComponents.default.button(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 0.75rem;\n  padding: 0;\n  margin-bottom: 1rem;\n  color: ", ";\n"])), function (props) {
  return props.theme.colorAccent;
});

var SignupStep = function SignupStep(_ref) {
  var translations = _ref.translations,
      isSubmitting = _ref.isSubmitting,
      onPageButtonClicked = _ref.onPageButtonClicked,
      onStepClicked = _ref.onStepClicked,
      setValues = _ref.setValues,
      isStepValid = _ref.isStepValid,
      values = _ref.values,
      errors = _ref.errors,
      dirty = _ref.dirty,
      handleChange = _ref.handleChange,
      signupError = _ref.signupError,
      termsSlug = _ref.termsSlug,
      privacySlug = _ref.privacySlug,
      handleBlur = _ref.handleBlur,
      useAssetsCdn = _ref.useAssetsCdn;
  (0, _react.useEffect)(function () {
    window.xtremepush("tag", "registration_contact_permissions", JSON.stringify({
      AppName: process.env.REACT_APP_TITLE
    }));
  }, []);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      checkAll = _useState2[0],
      setCheckAll = _useState2[1];

  var handleCheckAllChecked = function handleCheckAllChecked(e) {
    if (e.target.checked) {
      setCheckAll(true);
      setValues(_objectSpread(_objectSpread({}, values), {}, {
        inAppNotificationsAccepted: true,
        smsNotificationsAccepted: true,
        emailNotificationsAccepted: true,
        agreedTerms: true,
        agreedPrivacy: true
      }));
    } else {
      setCheckAll(false);
      setValues(_objectSpread(_objectSpread({}, values), {}, {
        inAppNotificationsAccepted: false,
        smsNotificationsAccepted: false,
        emailNotificationsAccepted: false,
        agreedTerms: false,
        agreedPrivacy: false
      }));
    }
  };

  return /*#__PURE__*/_react.default.createElement(StyledWrapper, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.TitleStack, {
    title: "".concat(translations.step, " 4"),
    subtitle: translations.messageConsent
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowLabel, null, translations.termsConditions), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    name: "agreedTerms",
    alignItems: "center",
    checked: values.agreedTerms,
    label: translations.confirmTermsConditions,
    onChange: function onChange(e) {
      window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      handleChange(e);
    },
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    type: "button",
    onClick: function onClick() {
      return onPageButtonClicked(termsSlug, translations.termsConditions, useAssetsCdn);
    }
  }, translations.termsConditions), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowLabel, null, translations.privacyCookies), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    name: "agreedPrivacy",
    alignItems: "center",
    checked: values.agreedPrivacy,
    label: translations.confirmPrivacyPolicy,
    onChange: function onChange(e) {
      window.xtremepush("tag", "Profile.TermsAndConditions", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      handleChange(e);
    },
    onBlur: handleBlur
  })), /*#__PURE__*/_react.default.createElement(StyledButton, {
    type: "button",
    onClick: function onClick() {
      return onPageButtonClicked(privacySlug, translations.privacyCookies, useAssetsCdn);
    }
  }, translations.privacyCookies), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.GdprCheckboxes, {
    message: translations.confirmMarketing,
    inAppNotificationsAccepted: values.inAppNotificationsAccepted,
    smsNotificationsAccepted: values.smsNotificationsAccepted,
    emailNotificationsAccepted: values.emailNotificationsAccepted,
    onChange: function onChange(e) {
      window.xtremepush("tag", "Profile.ContactPreferences", JSON.stringify({
        AppName: process.env.REACT_APP_TITLE
      }));
      handleChange(e);
    },
    onBlur: handleBlur
  }), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowText, null, translations.messageConsent)), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormCheckbox, {
    name: "checkAll",
    alignItems: "center",
    checked: checkAll && values.agreedTerms && values.agreedPrivacy && values.inAppNotificationsAccepted && values.smsNotificationsAccepted && values.emailNotificationsAccepted,
    label: translations.confirmAgreeAll,
    onChange: handleCheckAllChecked,
    onBlur: handleBlur
  })), errors.agreedTerms || errors.agreedPrivacy ? /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Alert, {
    isDanger: true,
    margin: "0 0 1rem"
  }, translations.messageTermsPrivacy) : null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    isLoading: isSubmitting,
    disabled: !isStepValid || !dirty,
    style: {
      marginBottom: "1rem"
    },
    onClick: function onClick() {
      return onStepClicked(4);
    }
  }, translations.next), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
    onClick: function onClick() {
      return onStepClicked(2);
    },
    isDefault: true
  }, translations.back));
};

var _default = SignupStep;
exports.default = _default;